import { DeliveryState } from "../../type/delivery-state";

export const clearDeliveryPageDispatch = (state: DeliveryState) => {
  state.deliveryPage = {
    contents: [],
    first: true,
    last: true,
    page: 0,
    totalPages: 1,
    totalElements: 0,
  };
};
